import { render, staticRenderFns } from "./VerifyMember.vue?vue&type=template&id=0fec219d&scoped=true"
import script from "./VerifyMember.vue?vue&type=script&lang=js"
export * from "./VerifyMember.vue?vue&type=script&lang=js"
import style0 from "./VerifyMember.vue?vue&type=style&index=0&id=0fec219d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec219d",
  null
  
)

export default component.exports